document.documentElement.classList.remove('no-js');

window.GGAnalytics = window.GGAnalytics || {
  track: function (eventName, payload) {
    if (!eventName) {
      return;
    }

    var detail = Object.assign({ event: eventName }, payload || {});
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(detail);

    try {
      document.dispatchEvent(new CustomEvent('gg:analytics', { detail: detail }));
    } catch (_error) {
    }
  }
};

document.addEventListener('DOMContentLoaded', function () {
  if (document.querySelector('.platform-landing-hero')) {
    window.GGAnalytics.track('platform_overview_view', {
      pageType: 'platform_landing'
    });
  }

  document.addEventListener('click', function (event) {
    var trackedTarget = event.target.closest('[data-gg-track]');
    if (!trackedTarget) {
      return;
    }

    window.GGAnalytics.track(trackedTarget.getAttribute('data-gg-track'), {
      label: trackedTarget.getAttribute('data-gg-label') || trackedTarget.textContent.trim(),
      location: trackedTarget.getAttribute('data-gg-location') || '',
      href: trackedTarget.getAttribute('href') || ''
    });
  });

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement)) {
      return;
    }

    var newsletterTagInput = form.querySelector('input[name="contact[tags]"]');
    if (newsletterTagInput && newsletterTagInput.value.indexOf('newsletter') !== -1) {
      var location = '';
      if (form.classList.contains('homepage-newsletter__form')) location = 'homepage';
      if (form.classList.contains('site-footer__form')) location = 'footer';
      if (form.classList.contains('editorial-newsletter-form')) location = 'editorial';
      if (form.classList.contains('product-email-capture__form')) location = 'product';
      window.GGAnalytics.track('newsletter_submit', {
        source: newsletterTagInput.value,
        location: location
      });
      return;
    }

    if (form.matches('.product-buybox__form')) {
      var variantInput = form.querySelector('[data-product-variant-id]');
      window.GGAnalytics.track('add_to_cart', {
        productId: (form.closest('[data-product-root]') && form.closest('[data-product-root]').getAttribute('data-product-id')) || '',
        productTitle: (form.closest('[data-product-root]') && form.closest('[data-product-root]').getAttribute('data-product-title')) || '',
        variantId: variantInput ? variantInput.value : ''
      });
    }
  });

  var header = document.querySelector('[data-header]');
  var toggle = document.querySelector('[data-nav-toggle]');
  if (!header || !toggle) {
    return;
  }

  var nav = header.querySelector('#SiteHeaderNav');

  function setNavState(isOpen) {
    header.classList.toggle('is-open', isOpen);
    toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    document.documentElement.classList.toggle('nav-open', isOpen);
  }

  toggle.addEventListener('click', function () {
    setNavState(!header.classList.contains('is-open'));
  });

  document.addEventListener('click', function (event) {
    if (!header.classList.contains('is-open')) {
      return;
    }

    if (header.contains(event.target)) {
      return;
    }

    setNavState(false);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && header.classList.contains('is-open')) {
      setNavState(false);
      toggle.focus();
    }
  });

  if (nav) {
    nav.addEventListener('click', function (event) {
      var link = event.target.closest('a');
      if (!link) {
        return;
      }

      if (window.matchMedia('(max-width: 990px)').matches) {
        setNavState(false);
      }
    });
  }

  window.addEventListener('resize', function () {
    if (window.innerWidth > 990 && header.classList.contains('is-open')) {
      setNavState(false);
    }
  });
});

document.addEventListener('DOMContentLoaded', function () {
  var productRoots = document.querySelectorAll('[data-product-root]');
  if (!productRoots.length) {
    return;
  }

  productRoots.forEach(function (root) {
    var form = root.querySelector('.product-buybox__form');
    var optionInputs = root.querySelectorAll('[data-product-option]');
    var variantInput = root.querySelector('[data-product-variant-id]');
    var priceNode = root.querySelector('[data-product-price]');
    var submit = root.querySelector('[data-product-submit]');
    var submitLabel = root.querySelector('[data-product-submit-label]');
    var statusNode = root.querySelector('[data-product-status]');
    var variantsScript = root.querySelector('[data-product-variants]');
    var gallery = document.querySelector('[data-product-gallery]');
    var galleryStage = gallery ? gallery.querySelector('[data-product-gallery-stage]') : null;
    var galleryImage = galleryStage ? galleryStage.querySelector('img') : null;
    var galleryThumbs = gallery ? gallery.querySelectorAll('[data-product-gallery-thumb]') : [];
    var lastTrackedVariantId = '';

    if (!form || !variantInput || !variantsScript) {
      return;
    }

    window.GGAnalytics.track('product_view', {
      productId: root.getAttribute('data-product-id') || '',
      productTitle: root.getAttribute('data-product-title') || ''
    });

    var variants = [];

    try {
      variants = JSON.parse(variantsScript.textContent);
    } catch (error) {
      variants = [];
    }

    function getSelectedOptions() {
      return Array.prototype.map.call(optionInputs, function (input) {
        return input.value;
      });
    }

    function findVariant() {
      var selected = getSelectedOptions();

      return variants.find(function (variant) {
        return [variant.option1, variant.option2, variant.option3]
          .slice(0, selected.length)
          .every(function (value, index) {
            return value === selected[index];
          });
      });
    }

    function setGalleryMedia(mediaId) {
      if (!gallery || !galleryStage || !galleryThumbs.length || !mediaId) {
        return;
      }

      var activeThumb = Array.prototype.find.call(galleryThumbs, function (thumb) {
        return thumb.getAttribute('data-media-id') === String(mediaId);
      });

      if (!activeThumb) {
        return;
      }

      var mediaSrc = activeThumb.getAttribute('data-media-src');
      var mediaAlt = activeThumb.getAttribute('data-media-alt') || '';

      if (galleryImage && mediaSrc) {
        galleryImage.src = mediaSrc;
        galleryImage.alt = mediaAlt;
      }

      galleryThumbs.forEach(function (thumb) {
        thumb.classList.toggle('is-active', thumb === activeThumb);
      });
    }

    function updateVariantState() {
      var matchedVariant = findVariant();
      if (!matchedVariant) {
        if (submit) {
          submit.disabled = true;
        }
        if (submitLabel) {
          submitLabel.textContent = 'Unavailable';
        }
        if (statusNode) {
          statusNode.textContent = 'This combination is not currently available.';
        }
        return;
      }

      variantInput.value = matchedVariant.id;

      if (priceNode) {
        priceNode.textContent = matchedVariant.price;
      }

      if (matchedVariant.id !== lastTrackedVariantId) {
        lastTrackedVariantId = matchedVariant.id;
        window.GGAnalytics.track('variant_select', {
          productId: root.getAttribute('data-product-id') || '',
          productTitle: root.getAttribute('data-product-title') || '',
          variantId: matchedVariant.id,
          available: matchedVariant.available
        });
      }

      if (submit) {
        submit.disabled = !matchedVariant.available;
      }

      if (submitLabel) {
        submitLabel.textContent = matchedVariant.available ? 'Add to cart' : 'Sold out';
      }

      if (statusNode) {
        statusNode.textContent = matchedVariant.available ? 'In stock' : 'Currently unavailable';
      }

      if (matchedVariant.featured_media_id) {
        setGalleryMedia(matchedVariant.featured_media_id);
      }
    }

    optionInputs.forEach(function (input) {
      input.addEventListener('change', updateVariantState);
    });

    galleryThumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var mediaSrc = thumb.getAttribute('data-media-src');
        var mediaAlt = thumb.getAttribute('data-media-alt') || '';

        if (galleryImage && mediaSrc) {
          galleryImage.src = mediaSrc;
          galleryImage.alt = mediaAlt;
        }

        galleryThumbs.forEach(function (node) {
          node.classList.toggle('is-active', node === thumb);
        });
      });
    });

    updateVariantState();
  });
});
